import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getScheduleTimeFrameRequest = {};
var _getScheduleTimeFrameResponse = {
    scheduleTimeFrame: '_scheduleTimeFrame',
};
var _listScheduleTimeFramesRequest = {};
var _listScheduleTimeFramesResponse = {
    scheduleTimeFrames: '_scheduleTimeFrame',
};
var _scheduleTimeFrame = {
    firstEventStartDate: '_zonedDate',
    lastEventEndDate: '_zonedDate',
    adjustedFirstEventStartDate: '_zonedDate',
    adjustedLastEventEndDate: '_zonedDate',
};
var _zonedDate = { utcDate: 'google.protobuf.Timestamp' };
function resolveWixCalendarScheduletimeframesV3ScheduleTimeFramesServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/schedule-timeframes-3',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/calendar/v3/schedules/timeframe',
                destPath: '/v3/schedules/timeframe',
            },
        ],
        _: [
            {
                srcPath: '/_api/calendar/v3/schedules/timeframe',
                destPath: '/v3/schedules/timeframe',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/calendar/v3/schedules/timeframe',
                destPath: '/v3/schedules/timeframe',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/calendar/v3/schedules/timeframe',
                destPath: '/v3/schedules/timeframe',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves the schedule time frame by schedule ID. */
export function getScheduleTimeFrame(payload) {
    var _a = serializer(_getScheduleTimeFrameRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getScheduleTimeFrameResponse, {
        _scheduleTimeFrame: _scheduleTimeFrame,
        _zonedDate: _zonedDate,
    }).fromJSON;
    function __getScheduleTimeFrame(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.schedule_time_frame',
            method: 'GET',
            methodFqn: 'wix.calendar.scheduletimeframes.v3.ScheduleTimeFramesService.GetScheduleTimeFrame',
            url: resolveWixCalendarScheduletimeframesV3ScheduleTimeFramesServiceUrl({
                protoPath: '/v3/schedules/timeframe/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getScheduleTimeFrame.fromReq = fromReq;
    __getScheduleTimeFrame.__isAmbassador = true;
    return __getScheduleTimeFrame;
}
/** Retrieves a list of schedule time frame by schedules ID. */
export function listScheduleTimeFrames(payload) {
    var _a = serializer(_listScheduleTimeFramesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listScheduleTimeFramesResponse, {
        _scheduleTimeFrame: _scheduleTimeFrame,
        _zonedDate: _zonedDate,
    }).fromJSON;
    function __listScheduleTimeFrames(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.schedule_time_frame',
            method: 'GET',
            methodFqn: 'wix.calendar.scheduletimeframes.v3.ScheduleTimeFramesService.ListScheduleTimeFrames',
            url: resolveWixCalendarScheduletimeframesV3ScheduleTimeFramesServiceUrl({
                protoPath: '/v3/schedules/timeframe',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listScheduleTimeFrames.fromReq = fromReq;
    __listScheduleTimeFrames.__isAmbassador = true;
    return __listScheduleTimeFrames;
}
//# sourceMappingURL=http.impl.js.map